module.exports = __webpack_public_path__ + "img/lightToDark.6ca18fab.gif";